import * as z from "zod";

export const deleteSegments = {
  name: "deleteSegments" as const,
  input: z.array(z.string()),
  output: z.null(),
};
